import ChatBubbleOutlineOutlined from "@mui/icons-material/ChatBubbleOutlineOutlined";
import CrisisAlertOutlined from "@mui/icons-material/CrisisAlertOutlined";
import DynamicFeedOutlined from "@mui/icons-material/DynamicFeedOutlined";
import EngineeringOutlined from "@mui/icons-material/EngineeringOutlined";
import EventNoteOutlined from "@mui/icons-material/EventNoteOutlined";
import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined";
import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import SpaceDashboardOutlined from "@mui/icons-material/SpaceDashboardOutlined";
import SupervisorAccountOutlined from "@mui/icons-material/SupervisorAccountOutlined";
import VolunteerActivismOutlined from "@mui/icons-material/VolunteerActivismOutlined";
import WarehouseOutlined from "@mui/icons-material/WarehouseOutlined";
import { ListItemIcon, ListItemText, Typography } from "@mui/material";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import { Link, useLocation } from "react-router-dom";
import { StyledSideNav } from "styles";

const itemSx = {
  borderRadius: "10px",
  mb: "2px",
  px: 1.5,
  py: 1,
  color: "#565B76",
  "& .MuiListItemIcon-root": { minWidth: 0, mr: 1.25, color: "#8288A6" },
  "&:hover": { background: "#F5F6FA" },
  "&.Mui-selected": {
    background: "#EEF0FA",
    boxShadow: "inset 3px 0 0 #1E2A8A",
    color: "#1E2A8A",
    "& .MuiListItemIcon-root": { color: "#1E2A8A" },
    "&:hover": { background: "#E7EAF7" },
  },
};

const groupLabelSx = {
  px: 1.5,
  pt: 2,
  pb: 0.5,
  fontFamily: "albertSans_semibold",
  fontSize: "10px",
  letterSpacing: "0.12em",
  textTransform: "uppercase",
  color: "#9AA0B5",
};

const sections = [
  {
    label: "Main",
    items: [
      { title: "Dashboard", path: "/dashboard", icon: SpaceDashboardOutlined },
      {
        title: "Service Bookings",
        path: "/service-bookings",
        icon: EventNoteOutlined,
      },
      {
        title: "Conversations",
        path: "/conversations",
        icon: ChatBubbleOutlineOutlined,
      },
      {
        title: "Managers",
        path: "/vkinnect-managers",
        icon: SupervisorAccountOutlined,
      },
      {
        title: "Volunteers",
        path: "/vkinnect-associates",
        icon: VolunteerActivismOutlined,
      },
      {
        title: "Service Partners",
        path: "/vkinnect-service-partners",
        icon: EngineeringOutlined,
      },
      {
        title: "Warehouse Team",
        path: "/vkinnect-warehouse",
        icon: WarehouseOutlined,
      },
      {
        title: "V-Kinnect Users",
        path: "/vkinnect-users",
        icon: PeopleAltOutlined,
      },
    ],
  },
  {
    label: "Manage",
    items: [
      {
        title: "V-Kinnect Feed",
        path: "/vkinnect-feed",
        icon: DynamicFeedOutlined,
      },
      {
        title: "Emergency Alerts",
        path: "/emergency-alerts",
        icon: CrisisAlertOutlined,
      },
      {
        title: "Shop for Yourself",
        path: "/shop-for-yourself",
        icon: ShoppingBagOutlined,
      },
      {
        title: "Configuration",
        path: "/configuration",
        icon: SettingsOutlined,
      },
    ],
  },
];

const SideBar = () => {
  const location = useLocation();

  return (
    <StyledSideNav>
      <List sx={{ px: 1.5, pt: 0, pb: 2 }}>
        {sections.map((section) => (
          <div key={section.label}>
            <Typography sx={groupLabelSx}>{section.label}</Typography>
            {section.items.map((item) => {
              const Icon = item.icon;
              const selected = location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  style={{ textDecoration: "none" }}
                >
                  <ListItemButton selected={selected} sx={itemSx}>
                    <ListItemIcon>
                      <Icon sx={{ fontSize: 20 }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={
                        <Typography
                          sx={{
                            color: "inherit",
                            fontSize: "14px",
                            fontFamily: selected
                              ? "albertSans_semibold"
                              : "albertSans_regular",
                          }}
                        >
                          {item.title}
                        </Typography>
                      }
                    />
                  </ListItemButton>
                </Link>
              );
            })}
          </div>
        ))}
      </List>
    </StyledSideNav>
  );
};

export default SideBar;
